export default __webpack_public_path__ + "static/media/Boots of the Shivering Stars.5f4786e6.jpg";